// Fictional but plausible data for HM Conseil Digital (HMCD)
// Note: All projects listed are illustrative examples for demo purposes.

export const COMPANY = {
  name: "HM Conseil Digital",
  short: "HMCD",
  phone: "01 89 40 83 75",
  phoneRaw: "0189408375",
  email: "contact@hmconseildigital.fr",
  address: "99 quai du docteur Dervaux",
  city: "92600 Asnières-sur-Seine",
  founded: "2015",
};

export const HERO_STATS = [
  { value: "420+", label: "Projets livrés" },
  { value: "98%", label: "Clients satisfaits" },
  { value: "1.2 GWh", label: "Énergie produite / an" },
  { value: "10 ans", label: "Garantie décennale" },
];

export const PARTICULIERS = [
  {
    id: "p1",
    title: "Maison contemporaine — Colombes",
    location: "Colombes (92)",
    year: "2024",
    kwc: "6 kWc",
    surfaceIte: "120 m²",
    dpeBefore: "E",
    dpeAfter: "B",
    savings: "1 840 €/an",
    payback: "8,2 ans",
    tags: ["Photovoltaïque", "ITE Polystyrène", "Enduit minéral"],
    image:
      "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMGZhY2FkZXxlbnwwfHx8fDE3OTA3NzgxMzl8MA&ixlib=rb-4.1.0&q=85",
    testimonial: {
      quote:
        "Chantier propre, équipe ponctuelle et un vrai suivi après la mise en service. La façade est méconnaissable et la facture EDF a fondu.",
      author: "Famille Bertaud",
      role: "Propriétaires",
    },
  },
  {
    id: "p2",
    title: "Pavillon années 70 — Nanterre",
    location: "Nanterre (92)",
    year: "2024",
    kwc: "9 kWc",
    surfaceIte: "145 m²",
    dpeBefore: "F",
    dpeAfter: "C",
    savings: "2 610 €/an",
    payback: "7,4 ans",
    tags: ["Photovoltaïque", "ITE Laine de roche", "Bardage bois"],
    image:
      "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZSUyMGZhY2FkZXxlbnwwfHx8fDE3OTA3NzgxMzl8MA&ixlib=rb-4.1.0&q=85",
    testimonial: {
      quote:
        "Nous sommes passés de F à C sur le DPE. En hiver, plus besoin de surchauffer le salon. Un vrai confort.",
      author: "Sabrina & Karim",
      role: "Propriétaires",
    },
  },
  {
    id: "p3",
    title: "Maison de ville — Rueil-Malmaison",
    location: "Rueil-Malmaison (92)",
    year: "2023",
    kwc: "4 kWc",
    surfaceIte: "95 m²",
    dpeBefore: "D",
    dpeAfter: "B",
    savings: "1 220 €/an",
    payback: "9,1 ans",
    tags: ["Photovoltaïque", "ITE Fibre bois", "Enduit teinté"],
    image:
      "https://images.unsplash.com/photo-1627141234469-24711efb373c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob3VzZSUyMGZhY2FkZXxlbnwwfHx8fDE3OTA3NzgxMzl8MA&ixlib=rb-4.1.0&q=85",
    testimonial: {
      quote:
        "L'équipe de HMCD a géré toutes les démarches MaPrimeRénov'. On n'a eu qu'à valider les rendus. Impeccable.",
      author: "Marc L.",
      role: "Propriétaire",
    },
  },
  {
    id: "p4",
    title: "Villa individuelle — Levallois",
    location: "Levallois-Perret (92)",
    year: "2024",
    kwc: "7 kWc",
    surfaceIte: "110 m²",
    dpeBefore: "E",
    dpeAfter: "A",
    savings: "2 180 €/an",
    payback: "7,8 ans",
    tags: ["Photovoltaïque", "Batterie 10 kWh", "ITE Polystyrène graphité"],
    image:
      "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z8ZW58MHx8fHwxNzkwNzc4MTM5fDA&ixlib=rb-4.1.0&q=85",
    testimonial: {
      quote:
        "Avec la batterie, on autoconsomme quasi 80 % de notre production. On revend le surplus à EDF OA.",
      author: "Céline P.",
      role: "Ingénieure — Propriétaire",
    },
  },
  {
    id: "p5",
    title: "Maison bourgeoise — Neuilly-sur-Seine",
    location: "Neuilly-sur-Seine (92)",
    year: "2023",
    kwc: "12 kWc",
    surfaceIte: "180 m²",
    dpeBefore: "D",
    dpeAfter: "A",
    savings: "3 940 €/an",
    payback: "8,6 ans",
    tags: ["Photovoltaïque premium", "ITE Enduit chaux", "Pompe à chaleur"],
    image:
      "https://images.unsplash.com/photo-1658298775754-5839ffd434cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z8ZW58MHx8fHwxNzkwNzc4MTM5fDA&ixlib=rb-4.1.0&q=85",
    testimonial: {
      quote:
        "Un chantier ambitieux mené sans accroc. HMCD a coordonné 4 corps de métier différents, on n'a jamais dû relancer personne.",
      author: "Alexandre D.",
      role: "Chef d'entreprise",
    },
  },
  {
    id: "p6",
    title: "Maison de famille — Boulogne-Billancourt",
    location: "Boulogne-Billancourt (92)",
    year: "2024",
    kwc: "5 kWc",
    surfaceIte: "100 m²",
    dpeBefore: "E",
    dpeAfter: "B",
    savings: "1 520 €/an",
    payback: "8,9 ans",
    tags: ["Photovoltaïque", "ITE sous bardage composite", "Volets isolés"],
    image:
      "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z8ZW58MHx8fHwxNzkwNzc4MTM5fDA&ixlib=rb-4.1.0&q=85",
    testimonial: {
      quote:
        "Trois générations sous le même toit — la maison est plus lumineuse, plus silencieuse et beaucoup moins énergivore.",
      author: "Nadia & Jean-Pierre",
      role: "Propriétaires",
    },
  },
];

export const PROFESSIONNELS = [
  {
    id: "b1",
    client: "Groupe Distri-Nord",
    site: "Supermarché — Asnières-sur-Seine",
    surface: "3 200 m² de toiture",
    power: "480 kWc",
    co2: "138 t CO₂ / an évitées",
    roi: "6,1 ans",
    year: "2023",
    scope: [
      "Étude structurelle et permis de construire",
      "Fourniture panneaux monocristallins 500 W",
      "Onduleurs triphasés — supervision temps réel",
      "Maintenance préventive 15 ans",
    ],
    image:
      "https://images.unsplash.com/photo-1726776230760-ae81dc9d4e55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBzb2xhciUyMHBhbmVscyUyMGNvbW1lcmNpYWwlMjBidWlsZGluZ3xlbnwwfHx8fDE3OTA3NzgxMzl8MA&ixlib=rb-4.1.0&q=85",
    quote:
      "HMCD a livré dans les temps, sans interrompre notre activité. La supervision temps réel est un vrai plus.",
    quoteBy: "Directeur technique — Groupe Distri-Nord",
  },
  {
    id: "b2",
    client: "Logistique Plus",
    site: "Entrepôt — Gennevilliers",
    surface: "7 800 m² de toiture",
    power: "1,1 MWc",
    co2: "312 t CO₂ / an évitées",
    roi: "5,4 ans",
    year: "2024",
    scope: [
      "Étude d'ombrage et calepinage",
      "Structure lestée sans percement",
      "Raccordement HTA Enedis",
      "Revente totale — contrat 20 ans",
    ],
    image:
      "https://images.unsplash.com/photo-1589275776107-e193042128bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBzb2xhciUyMHBhbmVscyUyMGNvbW1lcmNpYWwlMjBidWlsZGluZ3xlbnwwfHx8fDE3OTA3NzgxMzl8MA&ixlib=rb-4.1.0&q=85",
    quote:
      "Le projet a été autofinancé grâce au contrat de revente. Zéro CAPEX, une source de revenu récurrente.",
    quoteBy: "Direction financière — Logistique Plus",
  },
  {
    id: "b3",
    client: "Foncière Grand Paris Ouest",
    site: "Immeuble de bureaux — Bois-Colombes",
    surface: "2 400 m² de façade + toiture",
    power: "220 kWc + ITE complète",
    co2: "76 t CO₂ / an évitées",
    roi: "9,2 ans",
    year: "2024",
    scope: [
      "ITE certifiée QB — enduit fibré",
      "Panneaux BIPV intégrés en toiture",
      "Bornes de recharge parking",
      "Certification BREEAM Very Good",
    ],
    image:
      "https://images.unsplash.com/photo-1524414139215-35c99f80112d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBleHRlcmlvcnxlbnwwfHx8fDE3OTA3NzgxMzl8MA&ixlib=rb-4.1.0&q=85",
    quote:
      "Un projet global — enveloppe + production. HMCD a piloté le tout et nous a fait gagner le label BREEAM.",
    quoteBy: "Directrice patrimoine — Foncière GPO",
  },
];

export const SERVICES = [
  {
    id: "s1",
    title: "Panneaux photovoltaïques",
    subtitle: "Haut rendement — monocristallin 500 W+",
    body: "Étude d'implantation, fourniture, pose et raccordement Enedis. Autoconsommation, revente ou hybride.",
    kpi: "Production +18 %",
  },
  {
    id: "s2",
    title: "Isolation Thermique Extérieure",
    subtitle: "ITE — polystyrène, laine de roche, fibre bois",
    body: "Traitement complet des ponts thermiques, finition enduit ou bardage. Certification RGE Qualibat.",
    kpi: "-40 % pertes",
  },
  {
    id: "s3",
    title: "Pompes à chaleur",
    subtitle: "Air/eau — Air/air — Géothermie",
    body: "Dimensionnement selon DPE, installation par nos frigoristes agréés. Compatible plancher chauffant.",
    kpi: "COP 4,5",
  },
  {
    id: "s4",
    title: "Stockage par batterie",
    subtitle: "Lithium-fer-phosphate 5 à 20 kWh",
    body: "Boostez votre autoconsommation la nuit. Pilotage par app, garantie 10 ans.",
    kpi: "80 % autoconso.",
  },
];

export const CERTIFICATIONS = [
  { label: "RGE QualiPV", detail: "Installateur photovoltaïque certifié" },
  { label: "Qualibat 7141", detail: "Isolation thermique extérieure" },
  { label: "Garantie Décennale", detail: "10 ans — AXA Assurances Pro" },
  { label: "MaPrimeRénov'", detail: "Mandataire administratif et financier" },
];
